import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ThreeDotsIcon from "../../../../Icon-SVG/ThreeDotsIcon";
import { useOnClickOutside } from "../../../../../utils/hook/useOnClickOutside";
import MiniMenu from "../../../../common/MiniMenu/MiniMenu";
import StaticAnalysisIcon from "../../../../Icon-SVG/StaticAnalysisIcon";
import TrashBucketIcon from "../../../../Icon-SVG/TrashBucketIcon";
import SandboxIcon from "../../../../Icon-SVG/SandboxIcon";
import AgentSandboxRequestsModal from "./AgentSandboxRequestsModal/AgentSandboxRequestsModal";
import Warning from "../../../../common/Warning/Warning";
import {
  RequestAnalyzeAgent,
  RequestDeleteAgentRecord,
  RequestYaraScanAgent,
} from "../../../../../store/actions/integrationsActions";
import LinkIcon2 from "../../../../Icon-SVG/LinkIcon2";
import { CopyClipboard } from "../../../../../store/actions/dashboardActions";
import { addNotification } from "../../../../../store/actions/notifierActions";
import { checkLicenseForAgent } from "../../../../../utils/function";

const AgentInstallationThreeDots = (props) => {
  const ref = useRef();
  const dispatch = useDispatch();

  const [menuOpen, setMenuOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState(false);
  const [sandboxRequestsOpen, setSandboxRequestsOpen] = useState(false);

  useOnClickOutside(ref, () => setMenuOpen(false));

  const serverProtocol = window.location.protocol;
  const serverHostname = window.location.hostname;

  const licenceCheck = useSelector((state) => state?.users.licenceCheck);
  const isLicenseOkay = checkLicenseForAgent(licenceCheck.licenceStatus, licenceCheck.integrations);

  const agentID = props?.row?.original?.agent_id || "";
  const clientID = props?.row?.original?.clientID || "";
  const downloadUrl = props?.row?.original?.downloadUrl || "";
  const macAddress = props?.row?.original?.macAddress || "";
  const hostname = props?.row?.original?.hostname || "";
  const cpuID = props?.row?.original?.cpuID || "";

  const iconOnClickHandler = (event) => {
    event.stopPropagation();
    setMenuOpen((prev) => !prev);
  };

  const requestAnalysisOnClickHandler = () => {
    if (isLicenseOkay) {
      setShow("request-scan");
      setMessage(
        clientID
          ? `Are you sure to request analysis for the agent: ${clientID}?`
          : "Are you sure to request analysis for the agent?",
      );
    } else {
      dispatch(
        addNotification({
          message: "Your license key has expired. Please contact CyberFortress Technology Team.",
          options: { variant: "error" },
        }),
      );
    }
  };

  const requestAnalysisConfirmationHandler = () => {
    setShow(false);
    dispatch(RequestAnalyzeAgent({ clientID, macAddress, hostname, cpuID }));
    setMenuOpen((prev) => !prev);
  };

  const requestYaraScanOnClickHandler = () => {
    if (isLicenseOkay) {
      setShow("request-yara-scan");
      setMessage(
        clientID
          ? `Are you sure to request a custom YARA rule scan for the agent: ${clientID}?`
          : "Are you sure to request a custom YARA rule scan for the agent?",
      );
    } else {
      dispatch(
        addNotification({
          message: "Your license key has expired. Please contact CyberFortress Technology Team.",
          options: { variant: "error" },
        }),
      );
    }
  };

  const requestYaraScanConfirmationHandler = () => {
    setShow(false);
    dispatch(RequestYaraScanAgent({ clientID, macAddress, hostname, cpuID }));
    setMenuOpen((prev) => !prev);
  };

  const sandboxRequestsOnClickHandler = () => {
    setSandboxRequestsOpen(true);
    setMenuOpen(false);
  };

  const copyDownloadUrlHandler = () => {
    if (isLicenseOkay) {
      if (serverProtocol && serverHostname && downloadUrl) {
        dispatch(CopyClipboard(`${serverProtocol}//${serverHostname}/${downloadUrl}`));
      }
      setMenuOpen((prev) => !prev);
    } else {
      dispatch(
        addNotification({
          message: "Your license key has expired. Please contact CyberFortress Technology Team.",
          options: { variant: "error" },
        }),
      );
    }
  };

  const deleteRecordHandler = () => {
    if (isLicenseOkay) {
      setShow("delete-record");
      setMessage(
        clientID
          ? `Are you sure to delete record for the agent: ${clientID}? If you click yes, all the data will be deleted including scan reports`
          : "Are you sure to delete record for the agent? If you click yes, all the data will be deleted including scan reports.",
      );
    } else {
      dispatch(
        addNotification({
          message: "Your license key has expired. Please contact CyberFortress Technology Team.",
          options: { variant: "error" },
        }),
      );
    }
  };

  const deleteRecordConfirmationHandler = () => {
    setShow(false);
    dispatch(RequestDeleteAgentRecord(agentID));
    setMenuOpen((prev) => !prev);
  };

  const confirmationHandler = () => {
    if (show === "request-scan") {
      requestAnalysisConfirmationHandler();
    } else if (show === "request-yara-scan") {
      requestYaraScanConfirmationHandler();
    } else if (show === "delete-record") {
      deleteRecordConfirmationHandler();
    }
  };

  return (
    <div className="agent-installation-threedots" ref={ref} onClick={(e) => e.stopPropagation()}>
      <div className="agent-installation-threedots__icon" onClick={iconOnClickHandler}>
        <ThreeDotsIcon />
      </div>
      <MiniMenu isOpen={menuOpen} className="agent-installation-threedots__menu">
        {downloadUrl ? (
          <div onClick={copyDownloadUrlHandler}>
            <LinkIcon2 color="var(--text-color-card)" height={19} width={19} />
            <span style={{ marginLeft: "2px", color: "var(--tabs-button-color)" }}> Copy URL</span>
          </div>
        ) : null}
        <div onClick={requestAnalysisOnClickHandler}>
          <StaticAnalysisIcon color="white" height={22} width={22} /> Request Scan
        </div>
        <div onClick={requestYaraScanOnClickHandler}>
          <StaticAnalysisIcon color="white" height={22} width={22} /> Request Yara Scan
        </div>
        <div onClick={sandboxRequestsOnClickHandler}>
          <SandboxIcon color="var(--text-color-card)" height={20} width={20} />
          <span style={{ marginLeft: "2px" }}> Sandbox Requests</span>
        </div>
        <div onClick={deleteRecordHandler}>
          <TrashBucketIcon color="var(--text-color-card)" height={21} width={21} /> Delete Record
        </div>
      </MiniMenu>
      {/* <Backdrop
        show={downloadOptions.downloadStarted}
        message={
          <DownloadMessage
            fileName={fileName}
            loaded={downloadOptions.loaded}
            total={downloadOptions.total}
            progress={downloadOptions.progress}
          />
        }
      /> */}
      {/* {submitPopupActive ? (
        <Modal active={submitPopupActive} setActive={setSubmitPopupActive} type="submit-popup">
          <SubmitPopup
            selectedFiles={submitFile}
            setSelectedFiles={setSubmitFile}
            vmOptions={desktopVmOptions.filter((vmOption) => vms.includes(vmOption.id))}
            onClose={closePopupHandler}
            onSubmit={submitHandler}
            renderContent={renderContent}
            showApplyAll={false}
            showFileList={false}
          />
        </Modal>
      ) : null} */}
      {sandboxRequestsOpen ? (
        <AgentSandboxRequestsModal
          agentId={agentID}
          hostname={hostname}
          onClose={() => setSandboxRequestsOpen(false)}
        />
      ) : null}
      <Warning
        onClickOk={confirmationHandler}
        show={show}
        setShow={setShow}
        text={message}
        article="Warning"
        cancelDisable={false}
      />
    </div>
  );
};

export default AgentInstallationThreeDots;
